import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OidcOAuthService } from '../entity-services/oidc-oauth.service';
import { AdminPortalAPIService } from '../entity-services/admin-portal-api.service';
import { ComponentInteractionService } from '../entity-services/component-interaction.service';
import { DatavirtualizationService } from '../entity-services/features/dataVirtualization/datavirtualization.service';
import { EntityConfigurationService } from '../entity-services/features/entityConfiguration/entity-configuration.service';
import { GridService } from '../entity-services/grid.service';
import { MessageService } from './shared/message/message.service';

@NgModule({
  imports: [
    CommonModule,
    
  ],
  providers: [
    OidcOAuthService,
    AdminPortalAPIService,
    ComponentInteractionService,
    EntityConfigurationService,
    DatavirtualizationService,
    GridService,
    MessageService
  ],

  declarations: []
})
export class EntityServicesModule { }
